var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4145 6V15.75C19.4145 15.9489 19.3355 16.1397 19.1948 16.2803C19.0542 16.421 18.8634 16.5 18.6645 16.5C18.4656 16.5 18.2748 16.421 18.1341 16.2803C17.9935 16.1397 17.9145 15.9489 17.9145 15.75V7.81031L7.1951 18.5306C7.05437 18.6714 6.8635 18.7504 6.66448 18.7504C6.46546 18.7504 6.27458 18.6714 6.13385 18.5306C5.99312 18.3899 5.91406 18.199 5.91406 18C5.91406 17.801 5.99312 17.6101 6.13385 17.4694L16.8542 6.75H8.91448C8.71557 6.75 8.5248 6.67098 8.38415 6.53033C8.2435 6.38968 8.16448 6.19891 8.16448 6C8.16448 5.80109 8.2435 5.61032 8.38415 5.46967C8.5248 5.32902 8.71557 5.25 8.91448 5.25H18.6645C18.8634 5.25 19.0542 5.32902 19.1948 5.46967C19.3355 5.61032 19.4145 5.80109 19.4145 6Z",
    fill: "#323E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/ArrowUpRight.b63fa960adb2932ed370e5b47ac205d7.svg";
export { ForwardRef as ReactComponent };